var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls},[_c('div',{class:`${_vm.prefixCls}-header`},[_c('div',{class:`${_vm.prefixCls}-header-carousel`},[_c('Carousel',{attrs:{"carouselData":_vm.swipeList,"height":"600px"}})],1)]),_c('div',{class:`${_vm.prefixCls}-content`},[_c('ContactWay'),_c('message-board'),_c('ReportBoard')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }